import leerCookie from '../Core/leerCookieHelper';

//Ocultamos, meditante la valid de una cookie, elementos que no se deben mostrar dentro de las applicaciones android y ios.

const EstoyEnApp = {
    Initialize() {
        const estoyEnApp = leerCookie('platform');

        if (estoyEnApp) {

            let DisplayNone = (elemento) => {
                elemento.map((item) => {
                    if (item !== null) {
                        item.style.display = 'none';
                    }
                });
            };

            //Agregar aqui el elemento que se desea ocultar:
            let elementos = [
                //Header
                document.querySelector('#header'),

                //Footer
                document.querySelector('#pie'),

                //Aside (tercera)
                document.querySelector('#aside'),

                //LA NACION en BreadCumb
                document.querySelector('.breadcrumb > a:first-child'),
                document.querySelector('.breadcrumb > span:nth-child(2)'),

                //Link Escapadas en prox Feriado
                document.querySelector('.proximo-feriado__titulo a'),

                //Section te Puede Interesar
                document.querySelector('#notas-sugeridas')
            ];

            DisplayNone(elementos);
        }
    }
};

export default EstoyEnApp;




// WEBPACK FOOTER //
// ./Statics/scripts/Modules/estoyEnApp.js